<template>
  <a-card>
    <template v-slot:title>
      <a-button type="link" icon="left" :href="routeUri('hyperion.product.detail.billers', { product_hash: product })">
        Back
      </a-button>

      Create Biller Product
    </template>

    <a-row>
      <a-col :span="12">
        <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" :form="form" @submit="submit">
          <a-form-item label="Biller">
            <single-biller-autocomplete @change="handleBillerSelected"></single-biller-autocomplete>
          </a-form-item>
          <a-form-item label="Biller Driver">
            <a-select
              v-decorator="['driver', { rules: [{ required: true, message: 'Please select biller driver!' }] },]"
              placeholder="Select Biller Driver"
              @change="handleDriverSelected">
              <a-select-option :value="driver.name" v-for="driver in drivers" v-bind:key="driver.id">
                {{ driver.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Driver Class Schema">
            <a-select
              v-decorator="['class_schema', { rules: [{ required: true, message: 'Please select driver class schema!' }] }]"
              placeholder="Select Driver Class Schema">
              <a-select-option v-for="schema in schemas" :key="schema" :value="schema">
                {{ schema }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Process Code Inq">
            <a-input placeholder="Process Code Inq" v-decorator="[ 'product_code', {rules: [ { required: true } ] } ]">
              <a-icon slot="prefix" type="code" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
          <a-form-item label="Process Code Pay">
            <a-input placeholder="Process Code Pay" v-decorator="[ 'sub_product_code', {rules: [ { required: true } ] } ]">
              <a-icon slot="prefix" type="code" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
          <a-form-item label="Institution Code">
            <a-input placeholder="Institution Code" v-decorator="[ 'institution_code', {rules: [ { required: false } ] } ]">
              <a-icon slot="prefix" type="code" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
          <a-form-item label="Priority">
            <a-input-number placeholder="Priority" v-decorator="[ 'priority', {rules: [ { required: true } ] } ]">
              <a-icon slot="prefix" type="to-top" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input-number>
          </a-form-item>
          <a-form-item label="Price Scheme">
            <a-select
              v-decorator="['price_scheme', { rules: [{ required: true, message: 'Please select price scheme!' }] },]"
              placeholder="Select Price Scheme">
              <a-select-option v-for="scheme in priceSchemes" :key="scheme" :value="scheme">
                {{ scheme }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Base Price">
            <a-input-number placeholder="Base Price" v-decorator="[ 'base_price', {initialValue: 0, rules: [ { required: true } ] } ]"
                            class="price-input">
            </a-input-number>
          </a-form-item>
          <a-form-item label="Admin Fee">
            <a-input-number placeholder="Admin Fee" v-decorator="[ 'admin_fee', {initialValue: 0, rules: [ { required: true } ] } ]"
                            class="price-input">
            </a-input-number>
          </a-form-item>
          <a-form-item label="Share Fee">
            <a-input-number placeholder="Share Fee" v-decorator="[ 'share_fee', {initialValue: 0, rules: [ { required: true } ] } ]"
                            class="price-input">
            </a-input-number>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
            <a-button type="primary" html-type="submit" :loading="loading">
              Submit
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import SingleBillerAutocomplete from "../../biller/single-biller-autocomplete";
export default {
  name: "create-biller-product",
  components: {SingleBillerAutocomplete},
  props: {
    product: {
      type: String,
      required: true
    },
    priceSchemes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      billers: [],
      drivers: [],
      schemas: [],
      options: {
        biller: {},
        driver: {}
      },
      form: this.$form.createForm(this, {name: 'coordinated'}),
    }
  },
  methods: {
    handleBillerSelected(biller) {
      this.options.biller = biller
      this.drivers = biller.drivers
    },
    handleDriverSelected(driver) {
      this.options.driver = this.drivers.filter(item => item.name === driver)[0]
    },
    getDriverSchemas(driver) {
      this.$http.get(this.routeUri('hyperion.biller.driver.schemas', {
        biller_hash: this.options.biller.hash,
        driver_hash: driver.hash
      })).then(res => (this.schemas = res.data))
        .catch(err => this.handleXhrError(err))
    },
    submit(e) {
      e.preventDefault()
      this.form.validateFields((err, formData) => {
        if (!err) {
          this.loading = true
          this.$http.post(this.routeUri('hyperion.product.biller.store', {
            product_hash: this.product,
          }), formData).then(res => this.handleSuccessResponse(res.data))
            .catch(err => this.handleXhrError(err))
            .finally(() => this.loading = false)
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = data.redirect, 3000)
    },
  },
  watch: {
    'options.driver': function (value) {
      this.getDriverSchemas(value)
    }
  }
}
</script>

<style scoped>
.price-input {
  min-width: 200px;
  width: 100%;
}
</style>
